import { gsap } from 'gsap';
import jQuery from "jquery";
import { PageHandler } from './PageHandler';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

export class ServicesPageHandler extends PageHandler {
    constructor(id) {
    	super(id);
        this.mainElemId = "services"
    }


    init() {
		this.events();
		gsap.set(".service:not(.pseudo)", {y: 100});
		ScrollTrigger.batch(".service:not(.pseudo)", {
			//interval: 0.1, // time window (in seconds) for batching to occur. 
			//batchMax: 3,   // maximum batch size (targets)
			onEnter: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: {each: 0.15}, overwrite: true}),
			// you can also define things like start, end, etc.
		});
    }

    ajax() {
	
	}

    destroy() {
    
    }

	events() {

		let mm = gsap.matchMedia();
		mm.add("(max-width: 768px)", () => {
			jQuery('.service:not(.pseudo)').on('click', function() {
				window.leaving = true;
				ajaxPH.maskOn(jQuery(this).data('href'));
			});
		});
		mm.add("(min-width: 769px)", () => {
			jQuery('body').on('click', '.service.pseudo i', function() {
				var $pseudo = jQuery('.service.pseudo');
				window.reverseServiceTl = gsap.timeline({ paused: true, onComplete: () => { window.clickedService = undefined; }})
					.to($pseudo.find('i, .text'), {autoAlpha: 0, duration: 0.4})
					.to($pseudo[0], {
						width: () => window.clickedService.width(), 
						top: () => window.clickedService.offset().top, 
						left: () => window.clickedService.offset().left, 
						height: () => window.clickedService.outerHeight(), duration: 0.4})
					.to($pseudo[0], {autoAlpha: 0, duration: 0.2})

				window.reverseServiceTl.play();
			});
			jQuery(window).on('resize', () => {
				if (window.serviceTl && window.clickedService)
				{
					window.serviceTl.invalidate();
					window.serviceTl.restart();
				}	
			});

			jQuery('.service:not(.pseudo)').on('click', function() {
				var $this = jQuery(this);
				window.clickedService = $this;
				var width = $this.width();
				var height = $this.outerHeight();
				var $pseudo = jQuery('.service.pseudo');
	
				var x = $this.offset().left;
				var y = $this.offset().top;
	
				$pseudo.html($this.html());
				$pseudo.find('i').removeClass('fa-plus').addClass('fa-times');
	
				gsap.set($pseudo[0], {
					top: y,
					left: x,
					width: width,
					height: height
				})
	
				gsap.set($pseudo.find('.text, i'), {display: "block", autoAlpha: 0})
	
				window.serviceTl = gsap.timeline({ paused: true })
					.to($pseudo[0], {autoAlpha: 1, duration: 0.2})
					.to($pseudo[0], {width: () => jQuery('.services-container').width(), top: () => {
						var isLastRow = window.clickedService.nextAll('.service').length <= 2;
						var y = window.clickedService.offset().top;
						if (isLastRow)
							return y - 60 - window.clickedService.outerHeight();
						return y;
					}, left: () => jQuery('.services-container').offset().left, height: () => {
						var gap = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--gap'));
						return 2*window.clickedService.outerHeight() + gap
					} , duration: 0.4})
					.to($pseudo.find('.img-container, h4, i, .text'), {autoAlpha: 1, duration: 0.4})
	
				window.serviceTl.play();
	
				gsap.to(window, {scrollTo: {y: $pseudo[0], offsetY: () => {
					return 100;
				}}, duration: 0.8, delay: 0.2 + 0.4 + 0.4})
	
			})
		})
		
		

	}

	transitions() {
		// gsap.fromTo('.services .intro', {backgroundSize: "600%"}, {backgroundSize: "100%", duration: 0.5, ease: 'power2.inout'});
	}
}